import React, { useEffect, useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';

interface props {
  initialSeconds: number;
  onReachZero: VoidFunction;
}

export const Counter: React.FC<props> = ({ initialSeconds, onReachZero }) => {
  const [time, setTime] = useState(initialSeconds);

  useEffect(() => {
    if (time <= 0) {
      onReachZero();
      return;
    }

    const timer = setInterval(() => {
      setTime(prevState => {
        if (prevState <= 0) {
          clearInterval(timer);
          onReachZero();
          return 0;
        } else return prevState - 1;
      });
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Text font="body-caption">
        <FormattedMessage id="permissionManager.assignees.counterInfo" />
      </Text>
      <b>
        {` Processing: ${`${Math.floor(time / 60)}`.padStart(2, '0')}:
        ${`${time % 60}`.padStart(2, '0')}`}
      </b>
    </div>
  );
};
